import { fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2';


$(document).ready(function() {

    $(document).on('click', '#apply-coupon', function(e) {
        e.preventDefault();

		//$('#cart-page-notifications').html('');
        $('#coupon-code').removeClass('is-invalid');

		if($('#coupon-code').val() == '') {
            $('#coupon-code').addClass('is-invalid');
            return false;
        }

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");
        values += '&code=' + $('#coupon-code').val();
        values += '&price=' + $('#coupon-code').data('price');
        values += '&total=' + $('#coupon-code').data('total');
		$.ajax({
            type: "POST",
            url: baseURL + "/reservation/apply-coupon",
            data: values,
            success: function(response) {
                if (response.status == 0) {
					$('#coupon-code').val('');
					Swal.fire({
						//icon: "success",
						// title: "Eroare!",
						html: response.message
					});
					// $('#cart-page-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
					// fadeOutNotifications('#cart-page-notifications .errors-wrapper');
                    return false;
                }

                if (response.status == 1) {
					var couponLabel = $('#apply-coupon').data('label');
                    $('#coupon-code').attr('readonly', 'readonly');
					$('#apply-coupon').text($('#apply-coupon').data('text-remove'));
					$('#apply-coupon').attr('id', 'remove-coupon');

					Swal.fire({
						//icon: "success",
						// title: "Success!",
						html: response.message
					});

					let html = `<div class="bm-totalcost_title">
                        <h5>${couponLabel}: <b>${response.coupon.code}</b></h5>
                        <h6>-${response.coupon.discount_value}${response.coupon.discount_symbol}</h6>
                    </div>`;
					$('.coupon-wrapper').html(html);
                    $('.coupon-wrapper').show();

					$('#total').text(response.total);

                    return false;
                }

				$('#coupon-code').val('');
				Swal.fire({
					//icon: "success",
					// title: "Eroare!",
					html: response.message
				});
				// $('#cart-page-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
				// fadeOutNotifications('#cart-page-notifications .errors-wrapper');
				return false;
            },
            error(error) {

            }
        });
    });

	$(document).on('click', '#remove-coupon', function(e) {
        e.preventDefault();

		var values = '_token=' + $("meta[name='csrf-token']").attr("content");
        values += '&total=' + $('#coupon-code').data('total');
		$.ajax({
            type: "POST",
            url: baseURL + "/reservation/remove-coupon",
            data: values,
            success: function(response) {

                if (response.status == 1) {

					$('.coupon-wrapper').html('');
                    $('.coupon-wrapper').hide();
					$('#coupon-code').val('');
					$('#coupon-code').removeAttr('readonly');
					$('#remove-coupon').text($('#remove-coupon').data('text-apply'));
					$('#remove-coupon').attr('id', 'apply-coupon');

					$('#total').text(response.total);

                    return false;
                }

				Swal.fire({
					//icon: "success",
					title: "Eroare!",
					html: response.message
				});
				// $('#cart-page-notifications').html('<div class="errors-wrapper"><p>Error: Something went wrong please contact an administrator!</p></div>');
				// fadeOutNotifications('#cart-page-notifications .errors-wrapper');
				return false;
            },
            error(error) {

            }
        });
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/coupons.js